import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function CareerLevel({ member }) {
  return (

    <ValueItem
      icon="career-level-icon"
      label="Career Level"
    >
      {member.career_level}
    </ValueItem>
  );
}

CareerLevel.propTypes = {
  member: PropTypes.object.isRequired,
};
